import { styled } from '@mui/system'
import { Box, IconButton } from '@mui/material'

export const Wrapper = styled(Box)(`
    position:relative;
    width: 40%;

    & input {
        padding-left: 28px !important; font-size: 13px; 
        font-weight: 400; // 300;
    }

    &.showCrossButton .MuiInputBase-root{
        padding-right: 36px;
    }
    &.showCrossButton .close{
        left: auto;
        right: 8px;
        padding: 0;
    }
`)

export const IconButtonWrapper = styled(IconButton)(`
    position:absolute;
    left: 8px;
    top: 8px;
    width: 19px;
    height: 19px;
`)
